import { render, staticRenderFns } from "./GeneralMedicines.vue?vue&type=template&id=43853dd4&scoped=true"
import script from "./GeneralMedicines.vue?vue&type=script&lang=js"
export * from "./GeneralMedicines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43853dd4",
  null
  
)

export default component.exports